import { Star } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const TestimonialCard = ({ testimonial }) => {
  const roleLabels = {
    landlord: "Landlord",
    tenant: "Tenant",
    investor: "Property Investor",
  };

  return (
    <Card className="testimonial-card border-slate-200 h-full" data-testid={`testimonial-${testimonial.id}`}>
      <CardContent className="p-8">
        <div className="flex gap-1 mb-4">
          {[...Array(testimonial.rating)].map((_, i) => (
            <Star key={i} className="w-5 h-5 fill-gold text-gold" />
          ))}
        </div>
        <p className="text-slate-600 mb-6 leading-relaxed">
          "{testimonial.content}"
        </p>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-navy flex items-center justify-center text-white font-heading font-semibold">
            {testimonial.name.split(' ').map(n => n[0]).join('')}
          </div>
          <div>
            <div className="font-heading font-semibold text-navy">{testimonial.name}</div>
            <div className="text-sm text-slate-500">{roleLabels[testimonial.role] || testimonial.role}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
